import { Box, IconButton, Typography } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { useStyles } from './styles';
import { DaysWeek } from '../../../../../../reportFolio/pages/notifications/pages/main/utils/enums/tabs';


const daysOfWeek = [
    { label:'L', value: DaysWeek.MONDAY },
    { label:'M', value: DaysWeek.TUESDAY },
    { label:'X', value: DaysWeek.WEDNESDAY },
    { label:'J', value: DaysWeek.THURSDAY },
    { label:'V', value: DaysWeek.FRIDAY },
    { label:'S', value: DaysWeek.SATURDAY },
    { label:'D', value: DaysWeek.SUNDAY },
]

export const DayOfWeeksSelector = ({ selectedDay, setSelectedDay, multiple, startDate }: { startDate: number | undefined; selectedDay: number[] , setSelectedDay?: Dispatch<SetStateAction<number[] >>, multiple:boolean }) => {
  // Almacena el día seleccionado

  const handleDayClick = (index:number) => {
    if (multiple && setSelectedDay) {
      setSelectedDay(prev => {
        if (!prev) return [index];

        // Si el día ya está seleccionado, lo removemos
        if (prev.includes(index)) {
          return prev.filter(day => day !== index);
        } else {
          return [...prev, index];
        }
      });
    } else if(setSelectedDay) {
      setSelectedDay(prev =>
        prev?.[0] === index ? [] : [index]
      );
    }
  };

  const styles = useStyles()


  return (
    <Box display="flex" justifyContent="space-between" /* gap={2}  *//* mt={4} */>
      {daysOfWeek.map(day => (
        <IconButton
          key={day.value}
          onClick={() => {
              handleDayClick(day.value)
            }}
          sx={styles.daysOfWeek(selectedDay?.includes(day.value) ?? false, startDate ? startDate==day.value : false)}
        >
          <Typography variant="h6" fontWeight="bold">
            {day.label}
          </Typography>
        </IconButton>
      ))}
    </Box>
  );
};

